import AlertCaution from '@rover/icons/svg/alert-caution.svg';
import AlertInfo from '@rover/icons/svg/alert-info.svg';
import AlertSuccess from '@rover/icons/svg/alert-success.svg';
import TrustLogo from '@rover/icons/svg/trust-logo.svg';
import type { RoverTheme } from '@rover/types/src/RoverTheme';
import type { SvgIcon } from '@rover/types/src/SvgIcon';

export enum BannerSeverity {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  SYSTEM = 'system',
  CAUTION = 'caution',
}

export const getBannerSeverityBackgroundColors = (
  theme: RoverTheme
): Record<BannerSeverity, string> => ({
  [BannerSeverity.DANGER]: theme.background.error.toString(),
  [BannerSeverity.WARNING]: theme.background.caution.toString(),
  [BannerSeverity.SUCCESS]: theme.background.success.toString(),
  [BannerSeverity.INFO]: theme.background.highlight.toString(),
  [BannerSeverity.SYSTEM]: theme.background.accent_secondary.toString(),
  [BannerSeverity.CAUTION]: theme.background.secondary.toString(),
});

export const BANNER_SEVERITY_ICONS: Record<BannerSeverity, SvgIcon> = {
  [BannerSeverity.DANGER]: AlertCaution,
  [BannerSeverity.WARNING]: AlertInfo,
  [BannerSeverity.SUCCESS]: AlertSuccess,
  [BannerSeverity.INFO]: AlertInfo,
  [BannerSeverity.SYSTEM]: TrustLogo,
  [BannerSeverity.CAUTION]: AlertCaution,
};

export const getBannerSeverityIconFillColors = (
  theme: RoverTheme
): Record<BannerSeverity, string> => ({
  [BannerSeverity.DANGER]: theme.colors.text.error.toString(),
  [BannerSeverity.WARNING]: theme.colors.text.attention_highlight.toString(),
  [BannerSeverity.SUCCESS]: theme.colors.text.success.toString(),
  [BannerSeverity.INFO]: theme.colors.border.highlight.toString(),
  [BannerSeverity.SYSTEM]: theme.colors.interactive_text.primary_active.toString(),
  [BannerSeverity.CAUTION]: theme.colors.text.secondary.toString(),
});
